import { dispatch } from "../../state/store";
import { setFWUVersions } from "../../state/ducks";

import httpClient from "../httpClient";
import { fwuVersionsUtil } from "../../utils";

const apiUrl = process.env.REACT_APP_MERCURY_API_URL;

const getRequestData = () => {
  return `${apiUrl}/firmwareUpdates`;
};

const fetchFWUVersions = async () => {
  const url = getRequestData();
  const result = await httpClient.get(url);

  if (result?.data?.data) {
    dispatch(setFWUVersions(fwuVersionsUtil.formatFWUVersions(result?.data?.data)));
  }

  return result;
};

const createFWUVersion = async (data) => {
  const url = getRequestData();

  return await httpClient.post(url, { data });
};

const getFileUploadUrls = async (packageId) => {
  const url = `${apiUrl}/otaUpdate/uploadPackageUri`;

  return await httpClient.get(`${url}?package_id=${packageId}`);
};

const deleteFWUVersion = async (version) => {
  const url = getRequestData();

  return await httpClient.remove(`${url}?version=${version}`);
};

const uploadFile = async (url, file) => {
  const blob = new Blob([file], { type: file.type });

  return await fetch(url, {
    method: "PUT",
    body: blob,
    headers: { Accept: "*/*", "Content-Type": "" }
  });
};

const fwuVersionsService = {
  fetchFWUVersions,
  createFWUVersion,
  deleteFWUVersion,
  getFileUploadUrls,
  uploadFile
};

export default fwuVersionsService;
